export const PARTY_ROLES = ['vendedor', 'comprador'];

export const PARTY_KINDS = {
  PERSON: 'pessoa_fisica',
  COMPANY: 'pessoa_juridica',
};

export const RELATION_TYPES = {
  PRINCIPAL: 'principal',
  REPRESENTATIVE: 'representante',
};

export const PARTY_SECTIONS = {
  PERSON: ['personal', 'address', 'encumbrances', 'attorney', 'documents'],
  BUYER_PERSON: ['personal', 'address', 'origin', 'documents'],
  COMPANY: ['company', 'address', 'documents'],
  REPRESENTATIVE: ['personal', 'documents'],
};

export const genderOptions = t => [
  { value: '', label: t('SALES_PARTIES.FORM.GENDER_PLACEHOLDER') },
  { value: 'M', label: t('SALES_PARTIES.FORM.GENDER_MALE') },
  { value: 'F', label: t('SALES_PARTIES.FORM.GENDER_FEMALE') },
];

export const maritalStatusOptions = t => [
  { value: '', label: t('SALES_PARTIES.FORM.MARITAL_STATUS_PLACEHOLDER') },
  { value: '1', label: t('SALES_PARTIES.FORM.MARITAL_MARRIED') },
  { value: '2', label: t('SALES_PARTIES.FORM.MARITAL_SINGLE') },
  { value: '3', label: t('SALES_PARTIES.FORM.MARITAL_DIVORCED') },
  { value: '4', label: t('SALES_PARTIES.FORM.MARITAL_WIDOWED') },
  { value: '5', label: t('SALES_PARTIES.FORM.MARITAL_SEPARATED') },
];

export const marriageRegimeOptions = t => [
  { value: '', label: t('SALES_PARTIES.FORM.MARRIAGE_REGIME_PLACEHOLDER') },
  { value: '1', label: t('SALES_PARTIES.FORM.REGIME_TOTAL_SEPARATION') },
  { value: '2', label: t('SALES_PARTIES.FORM.REGIME_PARTIAL_SEPARATION') },
  { value: '3', label: t('SALES_PARTIES.FORM.REGIME_LEGAL_SEPARATION') },
  { value: '4', label: t('SALES_PARTIES.FORM.REGIME_COMMUNITY') },
  { value: '5', label: t('SALES_PARTIES.FORM.REGIME_PARTIAL_COMMUNITY') },
];

export const encumbranceOptions = t => [
  { value: '1', label: t('SALES_PARTIES.ENCUMBRANCES.CONSTRUCTION') },
  { value: '2', label: t('SALES_PARTIES.ENCUMBRANCES.MARRIAGE') },
  { value: '3', label: t('SALES_PARTIES.ENCUMBRANCES.STREET') },
  {
    value: '4',
    label: t('SALES_PARTIES.ENCUMBRANCES.MUNICIPAL_REGISTRATION'),
  },
  {
    value: '5',
    label: t('SALES_PARTIES.ENCUMBRANCES.USUFRUCT_CANCELLATION'),
  },
  {
    value: '6',
    label: t('SALES_PARTIES.ENCUMBRANCES.SEPARATION_DIVORCE'),
  },
  { value: '7', label: t('SALES_PARTIES.ENCUMBRANCES.STABLE_UNION') },
  { value: '8', label: t('SALES_PARTIES.ENCUMBRANCES.LEGAL_AGE') },
  {
    value: '9',
    label: t('SALES_PARTIES.ENCUMBRANCES.FIDUCIARY_RELEASE'),
  },
];

export const initialProfile = party => ({
  company: {},
  address: {},
  attorney: { enabled: false },
  encumbrances: [],
  encumbrances_enabled: Boolean(
    party?.profile?.encumbrances_enabled || party?.profile?.encumbrances?.length
  ),
  origin: {},
  documents: {},
  ...(party?.profile || {}),
  identity: {
    nationality: 'Brasileira',
    country_code: '55',
    ...(party?.profile?.identity || {}),
  },
});

export const sectionsForParty = (party, originRequired = false) => {
  if (party?.relation_type === RELATION_TYPES.REPRESENTATIVE) {
    return PARTY_SECTIONS.REPRESENTATIVE;
  }

  if (party?.party_kind === PARTY_KINDS.COMPANY) {
    return originRequired
      ? ['company', 'address', 'origin', 'documents']
      : PARTY_SECTIONS.COMPANY;
  }

  if (party?.party_role === 'comprador' && originRequired) {
    return PARTY_SECTIONS.BUYER_PERSON;
  }

  if (party?.party_role === 'comprador') {
    return ['personal', 'address', 'documents'];
  }

  return PARTY_SECTIONS.PERSON;
};

export const sectionLabels = t => ({
  personal: t('SALES_PARTIES.SECTIONS.PERSONAL'),
  company: t('SALES_PARTIES.SECTIONS.COMPANY'),
  address: t('SALES_PARTIES.SECTIONS.ADDRESS'),
  attorney: t('SALES_PARTIES.SECTIONS.ATTORNEY'),
  encumbrances: t('SALES_PARTIES.SECTIONS.ENCUMBRANCES'),
  origin: t('SALES_PARTIES.SECTIONS.ORIGIN'),
  documents: t('SALES_PARTIES.SECTIONS.DOCUMENTS'),
});
